import {Component, Input, OnInit} from '@angular/core';
import {UserModel} from '../../../../models/user.model';

@Component({
  selector: 'app-author-summary-part',
  templateUrl: './author-summary-part.component.html',
  styleUrls: ['./author-summary-part.component.scss']
})
export class AuthorSummaryPartComponent implements OnInit {

  @Input() authors:UserModel[]=[];
  constructor() { }

  ngOnInit() {
  }}



// WEBPACK FOOTER //
// ./src/app/+app-custom/components/publication-registration/base-summary-form-part/author-summary-part/author-summary-part.component.ts